import { Grid } from "@kiwicom/orbit-components";
import ImageInGrid from "../../../../src/documentation/06-kiwi-use/02-content/04-social-media/ImageInGrid";
import * as React from 'react';
export default {
  Grid,
  ImageInGrid,
  React
};